/**
 * Parses a Path2D: the Node2D surface plus the raw `curve` reference, which the
 * component resolves and tessellates.
 */
import { parseNode2D } from '../../base/node2d/parser';
export function parsePath2D(heading, properties) {
    const base = parseNode2D(heading, properties);
    const result = { ...base };
    if (properties.curve)
        result.curve = properties.curve;
    return result;
}
//# sourceMappingURL=parser.js.map